import {useEffect, useState} from 'react'
import {useContentfulClient} from './use-contentful-client.hook'
import {useIntl} from 'react-intl'
import {formatData} from '../../../utils'

export const useIngredients = () => {
    const {locale} = useIntl()
    const [data, setData] = useState(null)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const contentfulClient = useContentfulClient()

    useEffect(() => {
        contentfulClient
            .getEntries({
                locale,
                content_type: 'ingredient',
                include: 10
            })
            .then((response) => {
                const items = (response?.items ?? []).map(({fields}) => {
                    return {
                        ...fields,
                        category: (fields?.category ?? []).map(
                            ({fields: category}) => {
                                const media = category?.media
                                    ? formatData(category?.media)
                                    : null
                                return {
                                    ...category,
                                    media
                                }
                            }
                        )
                    }
                })
                if (items?.length > 0) setData(items)
            })
            .catch((error) => setError(error))
            .finally(() => setIsLoading(false))
    }, [])

    return {data, error, isLoading}
}
